import { render, staticRenderFns } from "./CalculationsTable.vue?vue&type=template&id=03c47d7d&scoped=true&"
import script from "./CalculationsTable.vue?vue&type=script&lang=js&"
export * from "./CalculationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c47d7d",
  null
  
)

export default component.exports